(() => {
  const storageKey = 'pinwall-favorite-handles-v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,250}(?:@[0-9]{1,20})?$/.test(value);
  let legacyFavorites={};
  try {legacyFavorites=JSON.parse(document.querySelector('[data-favorite-migrations]')?.textContent||'{}');}catch{}
  function readFavorites() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(validHandle).map(handle=>legacyFavorites[handle]||handle))].slice(0,100) : [];
    } catch { return []; }
  }
  function toast(message) {
    const element = document.querySelector('[data-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('visible');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => element.classList.remove('visible'),3000);
  }
  function updateButtons() {
    const favorites = readFavorites();
    document.querySelectorAll('[data-save-pin]').forEach(button => button.setAttribute('aria-pressed',String(favorites.includes(button.dataset.savePin))));
  }
  function favoriteAction(event) {
    const button = event.target.closest('[data-save-pin]');
    if (!button || !validHandle(button.dataset.savePin)) return;
    const handle = button.dataset.savePin;
    const current = readFavorites();
    const isSaved = current.includes(handle);
    const next = isSaved ? current.filter(value => value !== handle) : [...current,handle].slice(-100);
    try { localStorage.setItem(storageKey,JSON.stringify(next)); }
    catch { toast(document.documentElement.lang.startsWith('en') ? 'This browser cannot save favorites right now.' : 'Favorites storage unavailable.'); return; }
    updateButtons();
    if (document.querySelector('[data-favorites]')) renderFavorites();
  }
  const element = (tag,className,text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  let favoritesRender = 0;
  async function renderFavorites() {
    const grid = document.querySelector('[data-favorites]');
    if (!grid) return;
    const generation = ++favoritesRender;
    const handles = readFavorites();
    grid.replaceChildren(element('p','',handles.length ? grid.dataset.loading : grid.dataset.empty));
    if (!handles.length) return;
    const root = window.Shopify?.routes?.root || '/';
    const currency = grid.dataset.currency || 'USD';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency});
    const cards = [];
    let failed = 0;
    const productRequests=new Map();
    for (let i=0;i<handles.length;i+=5) {
      const results = await Promise.allSettled(handles.slice(i,i+5).map(async savedKey => {
        const [handle,variantId]=savedKey.split('@');
        if(!productRequests.has(handle))productRequests.set(handle,fetch(`${root}products/${encodeURIComponent(handle)}.js`,{signal:AbortSignal.timeout(12000)}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();}));
        const product=await productRequests.get(handle);
        const variant=variantId?product.variants.find(item=>String(item.id)===variantId):null;
        const variantTitle=variant?.public_title||variant?.title;
        const displayTitle=variant?(product.tags?.includes('Cookie Family')?`${variantTitle} — Christmas Cookie Pin`:`${product.title} — ${variantTitle}`):product.title;
        const displayImage=variant?.featured_image?.src||product.featured_image;
        const available=variant?variant.available:product.available;
        const price=variant?variant.price:product.price;
        const card = element('article','product-card');
        const imageBox = element('div','card-image');
        const link = element('a');
        link.href = `${root}products/${handle}${variantId?'?variant='+variantId:''}`;
        if (displayImage) {
          const img = element('img');
          const source = new URL(displayImage,location.origin);
          if (source.protocol !== 'https:' && source.origin !== location.origin) throw new Error('Invalid image');
          source.searchParams.set('width','640');
          img.src = source.href; img.alt = displayTitle; img.loading = 'lazy'; img.width = 640; img.height = 640;
          link.append(img);
        }
        imageBox.append(link);
        if (!available) { const badges = element('div','card-badges'); badges.append(element('span','badge sold-out',grid.dataset.sold)); imageBox.append(badges); }
        const info = element('div','card-info');
        const title = element('h3'); const titleLink = element('a','',displayTitle); titleLink.href = link.href; title.append(titleLink);
        const priceLine=element('p','card-price');priceLine.append(element('span','',money.format(price/100)));const compare=variant?variant.compare_at_price:product.compare_at_price;if(compare>price)priceLine.append(element('s','',money.format(compare/100)));const quick = element('a','card-arrow card-quick-add','+'); quick.href=link.href; quick.dataset.quickShop=''; quick.setAttribute('aria-label',displayTitle); priceLine.append(quick);info.append(title,priceLine);
        const remove = element('button','favorite-remove',grid.dataset.remove); remove.type='button'; remove.dataset.savePin=savedKey; remove.setAttribute('aria-pressed','true');
        info.append(remove); card.append(imageBox,info); return card;
      }));
      if (generation !== favoritesRender) return;
      for (const result of results) { if (result.status === 'fulfilled') cards.push(result.value); else failed++; }
    }
    grid.replaceChildren(...cards);
    if (failed) grid.append(element('p','',grid.dataset.error));
  }
  function init() {
    updateButtons();
    renderFavorites();
    document.querySelectorAll('[data-sort]').forEach(select => {
      if (select.dataset.enhanced) return;
      select.dataset.enhanced='true';
      select.addEventListener('change',() => select.form.requestSubmit());
    });
    document.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.enhanced) return;
      select.dataset.enhanced='true';
      select.addEventListener('change',() => {
        const variant = select.selectedOptions[0];
        const product = select.closest('.product-details');
        const button = product.querySelector('[data-add-button]');
        const price = product.querySelector('[data-product-price]');
        const quantity = product.querySelector('[name="quantity"]');
        const stock = product.querySelector('[data-stock-message]');
        const available = variant.dataset.available === 'true';
        if (button) { button.disabled = !available; (button.querySelector('[data-add-label]')||button).textContent = available ? button.dataset.labelAvailable : button.dataset.labelUnavailable; }
        if (price) price.textContent = variant.dataset.price;
        const compare=product.querySelector('[data-product-compare]');
        if(compare){compare.textContent=variant.dataset.compare||'';compare.hidden=!variant.dataset.compare;}
        if (quantity) {
          if (variant.dataset.max && available) quantity.max = variant.dataset.max; else quantity.removeAttribute('max');
          if (available && quantity.max && Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
        }
        if (stock) stock.textContent = available ? variant.dataset.stock : button.dataset.labelUnavailable;
        const layout=select.closest('.product-layout');
        const gallery=layout.querySelector('[data-variant-gallery]');
        if(gallery&&variant.dataset.image){const img=gallery.querySelector('img');img.removeAttribute('srcset');img.src=variant.dataset.image;img.alt=variant.dataset.title;gallery.href=variant.dataset.image;}
        layout.querySelectorAll('[data-variant-choice]').forEach(item=>item.setAttribute('aria-pressed',String(item.dataset.variantChoice===variant.value)));
        const save=product.querySelector('[data-save-pin]');
        if(save&&select.hasAttribute('data-variant-product')){save.dataset.savePin=`${select.dataset.productHandle}@${variant.value}`;updateButtons();}
        const sku=product.querySelector('[data-product-sku] span');if(sku)sku.textContent=variant.dataset.sku||'';
        const url = new URL(location.href); url.searchParams.set('variant',variant.value); history.replaceState({},'',url);
      });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }),{threshold:.08});
      document.querySelectorAll('[data-reveal]').forEach(section => observer.observe(section));
    }
    document.querySelectorAll('.mobile-menu').forEach(menu => {
      menu.addEventListener('keydown',event => { if(event.key==='Escape') { menu.open=false; menu.querySelector('summary').focus(); } });
    });
  }
  document.addEventListener('click',favoriteAction);
  addEventListener('storage',event => { if(event.key===storageKey) { updateButtons(); renderFavorites(); } });
  document.addEventListener('shopify:section:load',init);
  init();
})();
